export enum BusinessEntityKind {
Company,
Group,
Branch,
Nothing,
}
